export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '特项名称',
      dataIndex: 'name',
      // width: 100,
    },
    {
      title: '特项代码',
      dataIndex: 'code',
    },
    // {
    //   title: '关联分类',
    //   dataIndex: 'categoryName',
    //   width: 100,
    // },
    {
      title: '描述',
      dataIndex: 'description',
    },
    {
      title: '是否启用',
      dataIndex: 'enabled',
      width: 100,
      render: (text, record) => {
        return text ? '是' : '否'
      },
    },
    {
      title: '操作',
      width: 100,
      render: 'optionCell',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'keyword',
      label: '代码名称',
    },
  ],
  footer: [
    {
      label: '新建',
      // auth: 'specialCodesButton1',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
